<!-- <h1 matDialogTitle>{{ title | translate }}</h1>
<div mat-dialog-content>{{ confirmMessage | translate }}</div>
<div mat-dialog-actions class="pt-24" style="float: right">
  <button
    mat-raised-button
    color="white"
    class="mat-warn mr-16"
    (click)="dialogRef.close(false)"
  >
    {{ negative_btn | translate }}
  </button>
  <button mat-raised-button class="mat-accent" (click)="dialogRef.close(true)">
    {{ positive_btn | translate }}
  </button>
</div> -->

<div
  class="dialog-content-wrapper donation-form-dialog"
  style="overflow: visible"
>
  <mat-toolbar class="mat-accent m-0" style="padding: 0 !important">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
      <span class="title dialog-title" matDialogTitle
        >{{ title | translate }}
      </span>

      <button
        class="close-btn"
        mat-icon-button
        (click)="dialogRef.close(false)"
      >
        <mat-icon class="close-icon">close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div
    mat-dialog-content
    class="field p-16 pb-0 m-0"
    fxLayout="column"
    fusePerfectScrollbar
    style="width: 100%"
  >
    <h3 class="fw-bolder" mat-dialog-content>
      <label
        ><span> {{ confirmMessage | translate }}</span></label
      >
    </h3>
  </div>
  <div
    mat-dialog-actions
    class="donation-btn m-0"
    fxLayout="row"
    fxLayoutAlign="end center"
    style="margin-top: 10px; float: right"
  >
    <button
      mat-raised-button
      color="white"
      class="mat-warn mr-16"
      (click)="dialogRef.close(false)"
    >
      {{ negative_btn | translate }}
    </button>
    <button
      mat-raised-button
      class="mat-accent"
      (click)="dialogRef.close(true)"
    >
      {{ positive_btn | translate }}
    </button>
  </div>
</div>
